/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// COUNTDOWN TIMER JS

    const selectors$W = {
  time: 'time',
  days: '[data-days]',
  hours: '[data-hours]',
  minutes: '[data-minutes]',
  seconds: '[data-seconds]',
  shopifySection: '.announcement__slide',
};

const attributes$z = {
  expirationBehavior: 'data-expiration-behavior',
};

const classes$H = {
  showMessage: 'show-message',
  hideCountdown: 'hidden',
};

const settings$3 = {
  hideSection: 'hide-section',
  showMessage: 'show-message',
};

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.shopifySection = this.closest(selectors$W.shopifySection);
    this.expirationBehavior = this.getAttribute(attributes$z.expirationBehavior);

    this.time = this.querySelector(selectors$W.time);
    this.daysContainer = this.querySelector('.timer_days');
    this.days = this.querySelector(selectors$W.days);
    this.hours = this.querySelector(selectors$W.hours);
    this.minutes = this.querySelector(selectors$W.minutes);
    this.seconds = this.querySelector(selectors$W.seconds);

    // Get the current and expiration dates in Unix timestamp format (milliseconds)
    this.endDate = Date.parse(this.time.dateTime);
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;

    this.shouldHideOnComplete = this.expirationBehavior === settings$3.hideSection;
    this.shouldShowMessage = this.expirationBehavior === settings$3.showMessage;

    this.update = this.update.bind(this);
  }

  connectedCallback() {
    if (isNaN(this.endDate)) {
      this.onComplete();
      return;
    }

    if (this.endDate <= Date.now()) {
      this.onComplete();
      return;
    }

    // Update the countdown every second
    this.interval = setInterval(this.update, 1000);
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  convertTime(timeInMs) {
    const days = this.formatDigits(parseInt(timeInMs / this.daysInMs, 10));
    timeInMs -= days * this.daysInMs;

    const hours = this.formatDigits(parseInt(timeInMs / this.hoursInMs, 10));
    timeInMs -= hours * this.hoursInMs;

    const minutes = this.formatDigits(parseInt(timeInMs / this.minutesInMs, 10));
    timeInMs -= minutes * this.minutesInMs;

    const seconds = this.formatDigits(parseInt(timeInMs / this.secondsInMs, 10));

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }

  formatDigits(number) {
    if (number < 10) number = '0' + number;
    return number;
  }

  render(timer) {
    if (timer.days === '00') {
      this.daysContainer.style.display = 'none'; // Hide completely so layout shifts
    } else {
      this.daysContainer.style.display = 'flex';
      this.days.textContent = timer.days;
    }

    this.hours.textContent = timer.hours;
    this.minutes.textContent = timer.minutes;
    this.seconds.textContent = timer.seconds;
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  onComplete() {
    this.render({
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    });

    if (this.shouldHideOnComplete) {
      this.shopifySection?.classList.add(classes$H.hideCountdown);
    }

    if (this.shouldShowMessage) {
      this.classList?.add(classes$H.showMessage);
    }
  }

  update() {
    const timeNow = new Date().getTime();
    const timeDiff = this.endDate - timeNow;

    if (timeDiff <= 0) {
      this.stopTimer();
      this.onComplete();
      return;
    }

    const timeRemaining = this.convertTime(timeDiff);
    this.render(timeRemaining);
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}



//ENDS
// Ticker bar

    const selectors$D = {
      frame: '[data-ticker-frame]',
      scale: '[data-ticker-scale]',
      text: '[data-ticker-text]',
      clone: 'data-clone',
    };

    const attributes$p = {
      autoplay: 'autoplay',
      speed: 'speed',
    };

    const classes$t = {
      animation: 'ticker--animated',
      unloaded: 'ticker--unloaded',
      comparitor: 'ticker__comparitor',
    };

    const settings$2 = {
      speed: 1.63, // 100px going to move for 1.63s
      space: 100, // 100px
    };

class Ticker extends HTMLElement {
  constructor() {
    super();

    this.autoplay = this.hasAttribute('autoplay');
    this.scale = this.querySelector('[data-ticker-scale]');
    this.text = this.querySelector('[data-ticker-text]');
    this.speed = this.hasAttribute('speed') ? this.getAttribute('speed') : 1;
    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add('ticker__comparitor');
    this.appendChild(this.comparitor);
    this.scale.classList.remove('unloaded');
    this.checkWidthEvent = this.checkWidth.bind(this);
  }

  connectedCallback() {
    this.checkWidth();
    this.addEventListener('theme:ticker:refresh', this.checkWidthEvent);
    screen.orientation.addEventListener('change', this.checkWidthEvent);
    document.addEventListener('theme:resize:width', this.checkWidthEvent);
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.checkWidthEvent);
  }

  checkWidth() {
    const padding = parseInt(window.getComputedStyle(this).paddingLeft.replace('px', '')) * 2;
    const isOverflowing = this.clientWidth - padding < this.comparitor.clientWidth;

    // Remove all existing clones before adding new ones
    const clones = this.scale.querySelectorAll('[data-clone]');
    clones.forEach((item) => item.remove());

    if (isOverflowing || this.autoplay) {
      this.text.classList.remove('ticker--animated');
      const limitClones = this.autoplay ? Math.ceil((window.innerWidth - padding) / this.text.clientWidth) : 2;

      for (let index = 0; index <= limitClones; index++) {
        const cloneSecond = this.text.cloneNode(true);
        cloneSecond.setAttribute('data-clone', '');
        this.scale.appendChild(cloneSecond);
      }

      const animationTimeFrame = ((this.text.clientWidth / 100) * Number(this.speed)).toFixed(2);
      this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);

      this.scale.querySelectorAll('[data-ticker-text]').forEach((text) => {
        text.classList.add('ticker--animated');
      });
    } else {
      this.text.classList.add('ticker--animated');
    }
  }
}

if (!customElements.get('ticker-bar')) {
  customElements.define('ticker-bar', Ticker);
}

// ============================================================================
// PARENT-CHILD CART ITEM SYNC
// ============================================================================
(function() {
  'use strict';

  let lastSyncTime = {};
  let isSyncing = false;

  async function syncChildQuantities(parentKey, newParentQty) {
    console.log('[PARENT-CHILD SYNC] Called with parentKey:', parentKey, 'newQty:', newParentQty);
    
    // Prevent overlapping syncs
    if (isSyncing) {
      console.log('[PARENT-CHILD SYNC] Already syncing, skipping');
      return;
    }

    const now = Date.now();
    if (lastSyncTime[parentKey] && (now - lastSyncTime[parentKey]) < 1000) {
      console.log('[PARENT-CHILD SYNC] Too soon, skipping');
      return;
    }
    lastSyncTime[parentKey] = now;
    isSyncing = true;

    try {
      // Fetch current cart
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await cartResponse.json();

      // Find the parent item first to get its product title
      const parentItem = cart.items.find(item => item.key === parentKey);
      if (!parentItem) {
        console.log('[PARENT-CHILD SYNC] Parent item not found');
        isSyncing = false;
        return;
      }
      
      const parentProductTitle = parentItem.product_title;
      console.log('[PARENT-CHILD SYNC] Parent product:', parentProductTitle);

      // Find ALL children of this parent (excluding Combo Curtains)
      const childItems = [];
      cart.items.forEach((item, index) => {
        // Skip Combo Curtains products as they are bundle products
        if (item.product_type === 'Combo Curtains') {
          return;
        }
        
        // STRICT: Only sync children that belong to THIS parent
        const hasParentKey = item.parent_line_key === parentKey;
        const hasAddonProperty = item.properties && 
                                  item.properties._main_product_name === parentProductTitle;
        
        if (hasParentKey || hasAddonProperty) {
          console.log('[PARENT-CHILD SYNC] Found child:', item.product_title, 'Current qty:', item.quantity);
          childItems.push({
            item: item,
            lineIndex: index + 1,
            key: item.key
          });
        }
      });

      if (childItems.length === 0) {
        isSyncing = false;
        return;
      }

      // Update children SEQUENTIALLY (one at a time) to avoid race conditions
      for (const child of childItems) {
        if (child.item.quantity !== newParentQty) {
          // Use the child's key for more reliable updates
          await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: child.key,
              quantity: newParentQty
            })
          });
          
          // Small delay between updates to ensure cart processes each change
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      // Wait a bit for all changes to be processed
      await new Promise(resolve => setTimeout(resolve, 200));

      // Fetch updated cart
      const updatedCartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const updatedCart = await updatedCartResponse.json();

      // Verify all children were updated correctly (excluding Combo Curtains)
      const verifyChildren = updatedCart.items.filter(item => {
        // Skip Combo Curtains products as they are bundle products
        if (item.product_type === 'Combo Curtains') {
          return false;
        }
        
        const hasParentKey = item.parent_line_key === parentKey;
        const hasAddonProperty = item.properties && (
          item.properties._main_product_name || 
          item.properties._addon_type
        );
        return hasParentKey || hasAddonProperty;
      });

      const allUpdated = verifyChildren.every(child => child.quantity === newParentQty);
      
      if (!allUpdated) {
        console.error('Warning: Not all children were updated correctly');
      }

      // Dispatch cart refresh event
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));

    } catch (err) {
      console.error('Failed to sync child item quantities:', err);
    } finally {
      isSyncing = false;
    }
  }

  document.addEventListener('input', function(e) {
    const input = e.target;
    
    if (input && input.classList.contains('quantity-selector__input')) {
      const lineItemElement = input.closest('line-item, tr.line-item');
      const isChildItem = lineItemElement && lineItemElement.getAttribute('data-child-item') === 'true';
      
      if (isChildItem) {
        return;
      }
      
      if (lineItemElement) {
        const lineIndex = parseInt(input.getAttribute('data-line'), 10);
        const newQty = parseInt(input.value, 10);
        
        clearTimeout(window.parentQtyUpdateTimer);
        window.parentQtyUpdateTimer = setTimeout(() => {
          fetch(`${Shopify.routes.root}cart.js`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(res => res.json())
          .then(cart => {
            const item = cart.items[lineIndex - 1];
            
            // Only call parent-child sync for Standard Curtains (NOT Combo Curtains)
            if (item && !item.parent_line_key && item.key && item.product_type !== 'Combo Curtains') {
              syncChildQuantities(item.key, newQty);
            }
          })
          .catch(err => {
            console.error('Failed to check parent item:', err);
          });
        }, 800);
      }
    }
  });

  document.addEventListener('click', function(e) {
    const button = e.target.closest('a[href*="/cart/change"]');
    
    if (button) {
      const lineItemElement = button.closest('line-item, tr.line-item');
      const isChildItem = lineItemElement && lineItemElement.getAttribute('data-child-item') === 'true';
      
      if (isChildItem) {
        return;
      }
      
      setTimeout(() => {
        fetch(`${Shopify.routes.root}cart.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(cart => {
          // Only check Standard Curtains parent items (NOT Combo Curtains)
          const parentItems = cart.items.filter(item => 
            !item.parent_line_key && item.product_type !== 'Combo Curtains'
          );
          
          parentItems.forEach(parent => {
            // Find children that belong to THIS parent only
            const children = cart.items.filter(child => {
              return child.parent_line_key === parent.key ||
                (child.properties && child.properties._main_product_name === parent.product_title);
            });
            
            if (children.length > 0) {
              const needsSync = children.some(child => child.quantity !== parent.quantity);
              if (needsSync) {
                setTimeout(() => {
                  syncChildQuantities(parent.key, parent.quantity);
                }, 200);
              }
            }
          });
        })
        .catch(err => {
          console.error('Failed to check cart after click:', err);
        });
      }, 500);
    }
  });

  document.documentElement.addEventListener('cart:updated', function(evt) {
    const cart = evt.detail.cart;
    if (!cart || !cart.items) {
      return;
    }

    // Only check Standard Curtains parent items (NOT Combo Curtains)
    const parentItems = cart.items.filter(item => 
      !item.parent_line_key && item.product_type !== 'Combo Curtains'
    );
    
    parentItems.forEach(parent => {
      // Find children that belong to THIS parent only
      const children = cart.items.filter(child => {
        return child.parent_line_key === parent.key ||
          (child.properties && child.properties._main_product_name === parent.product_title);
      });
      
      if (children.length > 0) {
        const needsSync = children.some(child => child.quantity !== parent.quantity);
        
        if (needsSync) {
          setTimeout(() => {
            syncChildQuantities(parent.key, parent.quantity);
          }, 200);
        }
      }
    });
  });

  // ============================================================================
  // COMBO CURTAINS BUNDLE SYNC (items linked by "For" property)
  // ============================================================================
  
  let isBundleSyncing = false;
  let lastBundleSyncTime = {};

  async function syncComboCurtainsBundle(changedItemKey, newQty) {
    if (isBundleSyncing) {
      console.log('[BUNDLE SYNC] Already syncing, skipping...');
      return;
    }

    const now = Date.now();
    if (lastBundleSyncTime[changedItemKey] && (now - lastBundleSyncTime[changedItemKey]) < 1000) {
      console.log('[BUNDLE SYNC] Too soon, skipping...');
      return;
    }
    lastBundleSyncTime[changedItemKey] = now;
    isBundleSyncing = true;

    try {
      console.log('[BUNDLE SYNC] Starting sync for:', changedItemKey, 'New qty:', newQty);
      
      // Fetch current cart
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await cartResponse.json();

      // Find the changed item
      const changedItem = cart.items.find(item => item.key === changedItemKey);
      if (!changedItem) {
        console.log('[BUNDLE SYNC] Changed item not found');
        isBundleSyncing = false;
        return;
      }

      console.log('[BUNDLE SYNC] Changed item:', changedItem.product_title, changedItem.product_type, changedItem.properties);

      let bundleItems = [];
      let mainProductTitle = '';

      // If changed item is Combo Curtains, find all related addons
      if (changedItem.product_type === 'Combo Curtains') {
        mainProductTitle = changedItem.product_title;
        console.log('[BUNDLE SYNC] Looking for addons with title:', mainProductTitle);
        
        bundleItems = cart.items.filter(item => {
          if (item.key === changedItemKey) {
            console.log('[BUNDLE SYNC] Skipping self:', item.product_title);
            return false;
          }
          
          if (!item.properties) {
            console.log('[BUNDLE SYNC] No properties:', item.product_title);
            return false;
          }
          
          // STRICT EXCLUSION: Standard Curtains parent-child items have _main_product_name OR _addon_type
          if (item.properties._main_product_name || item.properties._addon_type) {
            console.log('[BUNDLE SYNC] ❌ EXCLUDED (Standard Curtains):', item.product_title, {
              _main_product_name: item.properties._main_product_name,
              _addon_type: item.properties._addon_type
            });
            return false;
          }
          
          // ONLY include items with _combo_bundle or _bundle_addon (Combo Curtains specific)
          if (item.properties._combo_bundle === mainProductTitle) {
            console.log('[BUNDLE SYNC] ✓ INCLUDED (_combo_bundle):', item.product_title);
            return true;
          }
          if (item.properties._bundle_addon && item.properties.For === mainProductTitle) {
            console.log('[BUNDLE SYNC] ✓ INCLUDED (_bundle_addon):', item.product_title);
            return true;
          }
          
          console.log('[BUNDLE SYNC] Not matched:', item.product_title, item.properties);
          return false;
        });
      } 
      // If changed item is a bundle addon
      else if (changedItem.properties) {
        // STRICT CHECK: Must have _combo_bundle or _bundle_addon AND NOT have _main_product_name or _addon_type
        if ((changedItem.properties._combo_bundle || changedItem.properties._bundle_addon) &&
            !changedItem.properties._main_product_name && 
            !changedItem.properties._addon_type) {
          mainProductTitle = changedItem.properties._combo_bundle || changedItem.properties.For;
        }
        
        if (mainProductTitle) {
          bundleItems = cart.items.filter(item => {
            if (item.key === changedItemKey) return false;
            
            // Include the main Combo Curtains product
            if (item.product_type === 'Combo Curtains' && item.product_title === mainProductTitle) {
              return true;
            }
            
            if (!item.properties) return false;
            
            // STRICT EXCLUSION: Standard Curtains items have _main_product_name OR _addon_type
            if (item.properties._main_product_name || item.properties._addon_type) {
              return false;
            }
            
            // ONLY include Combo Curtains bundle addons
            if (item.properties._combo_bundle === mainProductTitle) return true;
            if (item.properties._bundle_addon && item.properties.For === mainProductTitle) return true;
            
            return false;
          });
        }
      }

      console.log('[BUNDLE SYNC] Found', bundleItems.length, 'bundle items to sync');
      
      if (bundleItems.length === 0) {
        console.log('[BUNDLE SYNC] No bundle items found, exiting');
        isBundleSyncing = false;
        return;
      }

      // Update all bundle items SEQUENTIALLY
      for (const bundleItem of bundleItems) {
        console.log('[BUNDLE SYNC] Checking item:', bundleItem.product_title, 'Current qty:', bundleItem.quantity, 'Target qty:', newQty);
        
        if (bundleItem.quantity !== newQty) {
          console.log('[BUNDLE SYNC] Updating to qty:', newQty);
          await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: bundleItem.key,
              quantity: newQty
            })
          });
          
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      // Wait for all changes to process
      await new Promise(resolve => setTimeout(resolve, 200));

      // Fetch updated cart and dispatch refresh event
      const updatedCartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const updatedCart = await updatedCartResponse.json();

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));

    } catch (err) {
      console.error('Failed to sync Combo Curtains bundle:', err);
    } finally {
      isBundleSyncing = false;
    }
  }

  // Enhanced input handler for Combo Curtains bundles
  document.addEventListener('input', function(e) {
    const input = e.target;
    
    if (input && input.classList.contains('quantity-selector__input')) {
      const lineItemElement = input.closest('line-item, tr.line-item');
      const lineIndex = parseInt(input.getAttribute('data-line'), 10);
      const newQty = parseInt(input.value, 10);
      
      clearTimeout(window.bundleQtyUpdateTimer);
      window.bundleQtyUpdateTimer = setTimeout(() => {
        fetch(`${Shopify.routes.root}cart.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(cart => {
          const item = cart.items[lineIndex - 1];
          
          if (item) {
            // Check if it's a Combo Curtains item or a bundle addon
            const isComboCurtains = item.product_type === 'Combo Curtains';
            
            // Check if it's a bundle addon (has _bundle_addon property)
            // STRICT EXCLUSION: Standard Curtains items have _main_product_name OR _addon_type
            const isBundleAddon = item.properties && 
                                  !item.properties._main_product_name && 
                                  !item.properties._addon_type &&
                                  (item.properties._combo_bundle || item.properties._bundle_addon);
            
            console.log('[INPUT HANDLER] Item:', item.product_title, 'Type:', item.product_type);
            console.log('[INPUT HANDLER] isComboCurtains:', isComboCurtains, 'isBundleAddon:', isBundleAddon);
            console.log('[INPUT HANDLER] Properties:', item.properties);
            
            if (isComboCurtains || isBundleAddon) {
              console.log('[INPUT HANDLER] Triggering bundle sync');
              syncComboCurtainsBundle(item.key, newQty);
            }
          }
        })
        .catch(err => {
          console.error('Failed to check bundle item:', err);
        });
      }, 800);
    }
  });

  // Enhanced click handler for Combo Curtains bundles
  document.addEventListener('click', function(e) {
    const button = e.target.closest('a[href*="/cart/change"]');
    
    if (button) {
      setTimeout(() => {
        fetch(`${Shopify.routes.root}cart.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(cart => {
          // Check for Combo Curtains bundles that need syncing
          const comboCurtainsItems = cart.items.filter(item => item.product_type === 'Combo Curtains');
          
          comboCurtainsItems.forEach(mainItem => {
            const bundleAddons = cart.items.filter(item => {
              if (!item.properties) return false;
              
              // STRICT EXCLUSION: Standard Curtains items have _main_product_name OR _addon_type
              if (item.properties._main_product_name || item.properties._addon_type) {
                return false;
              }
              
              // ONLY include Combo Curtains bundle addons
              if (item.properties._combo_bundle === mainItem.product_title) return true;
              if (item.properties._bundle_addon && item.properties.For === mainItem.product_title) return true;
              
              return false;
            });
            
            if (bundleAddons.length > 0) {
              const needsSync = bundleAddons.some(addon => addon.quantity !== mainItem.quantity);
              if (needsSync) {
                setTimeout(() => {
                  syncComboCurtainsBundle(mainItem.key, mainItem.quantity);
                }, 200);
              }
            }
          });
        })
        .catch(err => {
          console.error('Failed to check cart after click:', err);
        });
      }, 500);
    }
  });

  // ============================================================================
  // AUTO-REMOVE BUNDLE ADDONS WHEN MAIN PRODUCT IS REMOVED
  // ============================================================================
  
  let isRemovingBundle = false;

  async function removeBundleAddons(mainProductTitle) {
    if (isRemovingBundle) {
      return;
    }
    isRemovingBundle = true;

    try {
      // Fetch current cart
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await cartResponse.json();

      // Find all bundle addons with matching bundle identifier
      // Works with _combo_bundle and _bundle_addon properties
      // STRICT EXCLUSION of Standard Curtains items
      const bundleAddons = cart.items.filter(item => {
        if (!item.properties) return false;
        
        // STRICT EXCLUSION: Standard Curtains items have _main_product_name OR _addon_type
        if (item.properties._main_product_name || item.properties._addon_type) {
          return false;
        }
        
        // ONLY include Combo Curtains bundle addons
        if (item.properties._combo_bundle === mainProductTitle) return true;
        if (item.properties._bundle_addon && item.properties.For === mainProductTitle) return true;
        
        return false;
      });

      if (bundleAddons.length === 0) {
        isRemovingBundle = false;
        return;
      }

      // Remove all bundle addons
      for (const addon of bundleAddons) {
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: addon.key,
            quantity: 0
          })
        });
        
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Wait for removals to process
      await new Promise(resolve => setTimeout(resolve, 200));

      // Fetch updated cart and dispatch refresh event
      const updatedCartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const updatedCart = await updatedCartResponse.json();

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));

    } catch (err) {
      console.error('Failed to remove bundle addons:', err);
    } finally {
      isRemovingBundle = false;
    }
  }

  // Monitor cart for removed Combo Curtains items
  let previousCartItemKeys = new Set();

  document.documentElement.addEventListener('cart:refresh', function(evt) {
    const cart = evt.detail.cart;
    if (!cart || !cart.items) {
      return;
    }

    const currentCartItemKeys = new Set(cart.items.map(item => item.key));
    
    // Check if any Combo Curtains items were removed
    if (previousCartItemKeys.size > 0) {
      const removedKeys = [...previousCartItemKeys].filter(key => !currentCartItemKeys.has(key));
      
      if (removedKeys.length > 0) {
        // Find removed items in previous cart state
        fetch(`${Shopify.routes.root}cart.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(currentCart => {
          // Check if we need to remove bundle addons
          const comboCurtainsInCart = currentCart.items.filter(item => item.product_type === 'Combo Curtains');
          const comboCurtainsTitles = new Set(comboCurtainsInCart.map(item => item.product_title));
          
          // Find bundle addons that no longer have their main product
          // STRICT EXCLUSION of Standard Curtains items
          const orphanedAddons = currentCart.items.filter(item => {
            if (!item.properties) return false;
            
            // STRICT EXCLUSION: Standard Curtains items have _main_product_name OR _addon_type
            if (item.properties._main_product_name || item.properties._addon_type) {
              return false;
            }
            
            // Check for _combo_bundle
            if (item.properties._combo_bundle && 
                !comboCurtainsTitles.has(item.properties._combo_bundle)) {
              return true;
            }
            
            // Check for _bundle_addon
            if (item.properties._bundle_addon && 
                item.properties.For &&
                !comboCurtainsTitles.has(item.properties.For)) {
              return true;
            }
            
            return false;
          });
          
          // Remove orphaned addons
          orphanedAddons.forEach(addon => {
            const bundleTitle = addon.properties._combo_bundle || addon.properties.For;
            if (bundleTitle) {
              removeBundleAddons(bundleTitle);
            }
          });
        });
      }
    }
    
    // Update previous cart state
    previousCartItemKeys = currentCartItemKeys;
  });

  // Handle remove link clicks for Combo Curtains
  document.addEventListener('click', function(e) {
    const removeLink = e.target.closest('a[href*="url_to_remove"]');
    
    if (removeLink) {
      const lineItemElement = removeLink.closest('line-item, tr.line-item');
      
      if (lineItemElement) {
        // Get the line index
        const quantityInput = lineItemElement.querySelector('.quantity-selector__input');
        
        if (quantityInput) {
          const lineIndex = parseInt(quantityInput.getAttribute('data-line'), 10);
          
          // Fetch cart to check if this is a Combo Curtains item
          fetch(`${Shopify.routes.root}cart.js`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(res => res.json())
          .then(cart => {
            const item = cart.items[lineIndex - 1];
            
            if (item && item.product_type === 'Combo Curtains') {
              // Delay to ensure main item is removed first
              setTimeout(() => {
                removeBundleAddons(item.product_title);
              }, 300);
            }
          })
          .catch(err => {
            console.error('Failed to check item for removal:', err);
          });
        }
      }
    }
  });

})();
